export default {"src":"/_next/static/media/combined.e249ec63.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};